import gql from "graphql-tag";
import { Query } from "react-apollo";
import { compose, graphql, ApolloProvider } from "react-apollo"; //apollo-client

import fetch from "node-fetch";
import reactStringReplace from "react-string-replace";
import CONTEXT from "./graphqlapi";
import client from "../../common/Apolloconfig/index";

const GQLSendNotification = gql`
  mutation sendNotification(
    $subject: String
    $message: String
    $userId: String
    $neighborhoodId: String
    $questionid: String
  ) {
    sendNotification(
      subject: $subject
      message: $message
      userId: $userId
      neighborhoodId: $neighborhoodId
      questionid: $questionid
    ) {
      success
      message
    }
  }
`;

async function sendNotification(noti_data) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLSendNotification,
        variables: {
          subject: noti_data.subject,
          message: noti_data.message,
          userId: noti_data.userId,
          neighborhoodId: noti_data.neighborhoodId,
          questionid: noti_data.questionid,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

const GQLSendQuestionNotification = gql`
  mutation sendQuestionNotification(
    $subject: String
    $message: String
    $userId: String
    $neighborhoodId: String
  ) {
    sendQuestionNotification(
      subject: $subject
      message: $message
      userId: $userId
      neighborhoodId: $neighborhoodId
    ) {
      success
      message
    }
  }
`;

async function sendQuestionNotification(noti_data) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQLSendQuestionNotification,
        variables: {
          subject: noti_data.subject,
          message: noti_data.message,
          userId: noti_data.userId,
          neighborhoodId: noti_data.neighborhoodId,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

const GQL_sendAgentContatEmail = gql`
  mutation sendAgentContatEmail(
    $name: String
    $message: String
    $email: String
    $phone: String
    $neighborhoodname: String
  ) {
    sendAgentContatEmail(
      name: $name
      message: $message
      email: $email
      phone: $phone
      neighborhoodname: $neighborhoodname
    ) {
      success
      message
    }
  }
`;

async function sendAgentContatEmail(noti_data) {
  return new Promise((resolve, reject) => {
    client
      .mutate({
        mutation: GQL_sendAgentContatEmail,
        variables: {
          name: noti_data.name,
          message: noti_data.message,
          email: noti_data.email,
          phone: noti_data.phone,
          neighborhoodname: noti_data.neighborhoodname,
        },
        context: CONTEXT,
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export { sendNotification, sendQuestionNotification, sendAgentContatEmail };
